"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groceryListItemFragment = exports.groceryRecipeInfoFragment = void 0;
const client_1 = require("@apollo/client");
exports.groceryRecipeInfoFragment = client_1.gql `
  fragment GroceryRecipeInfo on Recipe {
    __typename
    id
    name
  }
`;
exports.groceryListItemFragment = client_1.gql `
  fragment GroceryListItem on GroceryItem {
    __typename
    id
    name
    amount
    unit
    keyword
    createdAt
    complete
    recipeLinkId
    groceryCategoryId
    groceryCategoryName
    recipeId
    ingredientId
  }
  ${exports.groceryRecipeInfoFragment}
`;
//# sourceMappingURL=groceryItem.js.map